import { T_KeyValue } from "@/types/app.type";

const bpApp = process;
let DEFAULT_LOCALE: string = "en";
const setDefaultLocale = (locale: string = "en") => {
    DEFAULT_LOCALE = locale;
}
const getDefaultLocale = (): string => {
    return DEFAULT_LOCALE;
}

let LOCALE: string = DEFAULT_LOCALE;
const setLocale = (locale: string = getDefaultLocale()) => {
    LOCALE = locale;
}
const getLocale = (): string => {
    return LOCALE;
}

let LOCALES: string[] = [getDefaultLocale()];
const setLocales = (locales: string[]) => {
    LOCALES = locales || [getDefaultLocale()];
    // console.log("LOCALES | set --- ", LOCALES)
}
const getLocales = (): string[] => {
    // console.log("LOCALES | get --- ", LOCALES)
    return LOCALES;
}

// console.log("app.config ----- ", bpApp.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN)

const NODE_ENV = process.env.NEXT_PUBLIC_NODE_ENV || "development";

// ---------Azure Insights---------
const APP_INSIGHTS_DEV = process.env.NEXT_PUBLIC_APP_INSIGHTS_DEV || "";
const INSTRUMENTATION_KEY = process.env.NEXT_PUBLIC_INSTRUMENTATION_KEY || "";

// ---------- App ---------
const APP_URL = bpApp?.env?.NEXT_PUBLIC_APP_URL || bpApp?.env?.APP_URL || ""; // || "https://localhost:3000";
// ---------- Preview Token ---------
const PT = bpApp?.env?.NEXT_PUBLIC_PREVIEW_TOKEN || bpApp?.env?.PREVIEW_TOKEN || ""
// console.log("env ----- ", bpApp)
const CONTENTFUL_ENV = bpApp?.env?.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT || bpApp?.env?.CONTENTFUL_ENVIRONMENT || process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT || "dev";

// ---------- Contentful ----------
const BASEPLATE_APP_CONFIG = bpApp?.env?.NEXT_PUBLIC_BASEPLATE_APP_CONFIG || bpApp?.env?.BASEPLATE_APP_CONFIG || process.env.NEXT_PUBLIC_BASEPLATE_APP_CONFIG || "";
// const BASEPLATE_APP_CONFIG_ID = bpApp?.env?.NEXT_PUBLIC_BASEPLATE_APP_CONFIG_ID || bpApp?.env?.BASEPLATE_APP_CONFIG_ID || "";
const CONTENTFUL_SPACE_ID = bpApp?.env?.NEXT_PUBLIC_CONTENTFUL_SPACE_ID || bpApp?.env?.CONTENTFUL_SPACE_ID || process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID || "";
const CPAT = (bpApp?.env?.NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN || bpApp?.env?.CONTENTFUL_PREVIEW_ACCESS_TOKEN) || process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN || "";
const CAT = bpApp?.env?.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN || bpApp?.env?.CONTENTFUL_ACCESS_TOKEN || process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN || "";

const APP_TAG_ID = bpApp?.env?.NEXT_PUBLIC_APP_TAG_ID || bpApp?.env?.APP_TAG_ID || process.env.NEXT_PUBLIC_APP_TAG_ID || "";
const DEFAULT_PAGE_CONTENT_TYPE = bpApp?.env?.NEXT_PUBLIC_DEFAULT_PAGE_CONTENT_TYPE || bpApp?.env?.DEFAULT_PAGE_CONTENT_TYPE || process.env.NEXT_PUBLIC_DEFAULT_PAGE_CONTENT_TYPE || "";
const DEFAULT_PAGE_TAG = bpApp?.env?.NEXT_PUBLIC_DEFAULT_PAGE_TAG || bpApp?.env?.DEFAULT_PAGE_TAG || process.env.NEXT_PUBLIC_DEFAULT_PAGE_TAG || "";
const HOME_PAGE_SLUG = bpApp?.env?.NEXT_PUBLIC_HOME_PAGE_SLUG || bpApp?.env?.HOME_PAGE_SLUG || process.env.NEXT_PUBLIC_HOME_PAGE_SLUG || "";

const APP_CONFIG_CONTENT_TYPE = bpApp?.env?.NEXT_PUBLIC_APP_CONFIG_CONTENT_TYPE || bpApp?.env?.APP_CONFIG_CONTENT_TYPE || process.env.NEXT_PUBLIC_APP_CONFIG_CONTENT_TYPE || "";
const TOP_MENU_CONTENT_TYPE = bpApp?.env?.NEXT_PUBLIC_TOP_MENU_CONTENT_TYPE || bpApp?.env?.TOP_MENU_CONTENT_TYPE || process.env.NEXT_PUBLIC_TOP_MENU_CONTENT_TYPE || "";
const FOOTER_CONTENT_TYPE = bpApp?.env?.NEXT_PUBLIC_FOOTER_CONTENT_TYPE || bpApp?.env?.FOOTER_CONTENT_TYPE || process.env.NEXT_PUBLIC_FOOTER_CONTENT_TYPE || "";
const CONTENTFUL_EXPERIENCE_TYPE = bpApp?.env?.NEXT_PUBLIC_CONTENTFUL_EXPERIENCE_TYPE || bpApp?.env?.CONTENTFUL_EXPERIENCE_TYPE || process.env.NEXT_PUBLIC_CONTENTFUL_EXPERIENCE_TYPE || "";
const FORM_CONTENT_TYPE = bpApp?.env?.NEXT_PUBLIC_FORM_CONTENT_TYPE || bpApp?.env?.FORM_CONTENT_TYPE || process.env.NEXT_PUBLIC_FORM_CONTENT_TYPE || "";

let GRAPH_QL_URL = `https://graphql.contentful.com/content/v1/spaces/${CONTENTFUL_SPACE_ID}`;
let REST_API_URL = `https://cdn.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/environments/${CONTENTFUL_ENV}`;
let REST_PREVIEW_API_URL = `https://preview.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/environments/${CONTENTFUL_ENV}`;


// ---------- Google Services ---------
const GTM_ID = bpApp?.env?.NEXT_PUBLIC_GTM_ID || bpApp?.env?.GTM_ID || process.env.NEXT_PUBLIC_GTM_ID || "";
const GA_ID = bpApp?.env?.NEXT_PUBLIC_GA_ID || bpApp?.env?.GA_ID || process.env.NEXT_PUBLIC_GA_ID || "";

// ---------- reCAPTCHA ------
const RECAPTCHA_SECRET_KEY = bpApp?.env?.NEXT_PUBLIC_RECAPTCHA_SECRET_KEY || bpApp?.env?.RECAPTCHA_SECRET_KEY || process.env.NEXT_PUBLIC_RECAPTCHA_SECRET_KEY || "";
const RECAPTCHA_SITE_KEY = bpApp?.env?.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || bpApp?.env?.RECAPTCHA_SITE_KEY || process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "";

// --------- Form Security ------
const CAPTCHAS_SECRET = bpApp?.env?.NEXT_PUBLIC_CAPTCHAS_SECRET || process.env.NEXT_PUBLIC_CAPTCHAS_SECRET || "";
const CAPTCHAS_CLIENT = bpApp?.env?.NEXT_PUBLIC_CAPTCHAS_CLIENT || process.env.NEXT_PUBLIC_CAPTCHAS_CLIENT || "";

const IFRAME_CATEGORY_ID=bpApp?.env?.NEXT_PUBLIC_IFRAME_CATEGORY_ID || process.env.NEXT_PUBLIC_IFRAME_CATEGORY_ID;
const PERFORMANCE_COOKIE_ID=bpApp?.env?.NEXT_PUBLIC_PERFORMANCE_COOKIE_ID || process.env.NEXT_PUBLIC_PERFORMANCE_COOKIE_ID;
const MARKETING_COOKIE_ID=bpApp?.env?.NEXT_PUBLIC_MARKETING_COOKIE_ID || process.env.NEXT_PUBLIC_MARKETING_COOKIE_ID;


// --------- Email ---------
const EMSE = bpApp?.env?.NEXT_PUBLIC_EMAIL_SECRET || bpApp?.env?.EMAIL_SECRET || process.env.NEXT_PUBLIC_EMAIL_SECRET || "";
const JSE = bpApp?.env?.NEXT_PUBLIC_JWT_SECRET || bpApp?.env?.JWT_SECRET || process.env.NEXT_PUBLIC_JWT_SECRET || "";
const ASK = bpApp?.env?.NEXT_PUBLIC_API_SUBSCRIPTION_KEY || bpApp?.env?.API_SUBSCRIPTION_KEY || process.env.NEXT_PUBLIC_API_SUBSCRIPTION_KEY || "";

// --------- Azure Secrete Key ------------
const AZURE_FUNCTION_SECRET = bpApp?.env?.NEXT_PUBLIC_AZURE_FUNCTION_SECRET_KEY || process.env.NEXT_PUBLIC_AZURE_FUNCTION_SECRET_KEY || "";
const AZURE_FUNC_ENDPOINT = bpApp?.env?.NEXT_PUBLIC_AZURE_FUNC_ENDPOINT || process.env.NEXT_PUBLIC_AZURE_FUNC_ENDPOINT || "";

const init = () => {
    GRAPH_QL_URL = `https://graphql.contentful.com/content/v1/spaces/${CONTENTFUL_SPACE_ID}`;
    REST_API_URL = `https://cdn.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/environments/${CONTENTFUL_ENV}`;
}

let HOST = "";

const setHost = (host: string) => {
    if(host) {HOST = host;}
}

const getHost = () => {
    return HOST;
}

let BP_CONFIG: T_KeyValue = {};
let DOMAIN_CONFIG: T_KeyValue = {};
let APP_CNF: any = {};
let EXPERIENCE: any = null;

const setBpConfig = (cnf: any) => { if(cnf) {BP_CONFIG = cnf;} }
const getBpConfig = () => BP_CONFIG;
// Domain config
const setDomainConfig = (cnf: any) => { if(cnf) {DOMAIN_CONFIG = cnf;} }
const getDomainConfig = () => DOMAIN_CONFIG;
// App Cnf
const setAppCnf = (cnf: any) => { if(cnf) {APP_CNF = cnf;} }
const getAppCnf = () => APP_CNF;

const setExperienceJSON = (experience: any) => { EXPERIENCE = experience; }
const getExperienceJSON = () => EXPERIENCE;

init();

// console.log("app.config ----- ", CPAT)

export {
    NODE_ENV,
    APP_INSIGHTS_DEV,
    INSTRUMENTATION_KEY,
    DEFAULT_LOCALE,
    LOCALE,
    LOCALES,
    APP_URL,
    CONTENTFUL_ENV,
    CONTENTFUL_SPACE_ID,
    CPAT,
    CAT,
    CAPTCHAS_SECRET,
    CAPTCHAS_CLIENT,
    BASEPLATE_APP_CONFIG,
    // BASEPLATE_APP_CONFIG_ID,
    APP_TAG_ID,
    DEFAULT_PAGE_CONTENT_TYPE,
    DEFAULT_PAGE_TAG,
    HOME_PAGE_SLUG,
    APP_CONFIG_CONTENT_TYPE,
    TOP_MENU_CONTENT_TYPE,
    FOOTER_CONTENT_TYPE,
    CONTENTFUL_EXPERIENCE_TYPE,
    FORM_CONTENT_TYPE,
    RECAPTCHA_SECRET_KEY,
    RECAPTCHA_SITE_KEY,
    GRAPH_QL_URL,
    REST_API_URL,
    REST_PREVIEW_API_URL,
    PT,
    GTM_ID,
    GA_ID,
    EMSE,
    JSE,
    ASK,
    setHost,
    getHost,
    setBpConfig,
    getBpConfig,
    setDefaultLocale,
    getDefaultLocale,
    setLocale,
    getLocale,
    setLocales,
    getLocales,
    IFRAME_CATEGORY_ID,
    PERFORMANCE_COOKIE_ID,
    MARKETING_COOKIE_ID,
    AZURE_FUNCTION_SECRET,
    AZURE_FUNC_ENDPOINT,
    setDomainConfig,
    getDomainConfig,
    setAppCnf,
    getAppCnf,
    setExperienceJSON,
    getExperienceJSON
}